import { combineReducers } from 'redux';
import { FoodCardItemDto } from '../dto/BaseResponse';

export const SET_BuyCard = 'SET_BuyCard';
export const ActionsBuyCard = {
    SetCard(data: Array<FoodCardItemDto>) {
        return { type: SET_BuyCard, items: data };
    }
}
const Card = (state = [], action: any) => {

    switch (action.type) {
        case SET_BuyCard:
            state = action.items;
            return state
        default:
            return state
    }
}
export const getCard = (state: any) => state.Card;
export default combineReducers({
    Card
});
